import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

interface IDateRange {
  fromDate: string | null;
  toDate: string | null;
  range: "day" | "week" | "month" | "total";
}
interface IFeedbackSlice {
  feedbackType: 1 | -1 | 0;
  logId: number;
  qaId: string;
  selectedDateRange: IDateRange;
  selectedMetros: string[];
  selectedRangeType: string;
}

// Helper function to get default week range
const getDefaultWeekRange = () => {
  const startOfWeek = moment().startOf('week');
  const endOfWeek = moment().endOf('week');
  
  return {
    fromDate: startOfWeek.format('YYYY-MM-DD'),
    toDate: endOfWeek.format('YYYY-MM-DD'),
    range: "week" as const
  };
};

export const feedbackInitialState: IFeedbackSlice = {
  feedbackType: 0,
  logId: 0,
  qaId: "",
  selectedDateRange: getDefaultWeekRange(),
  selectedRangeType: "week", 
  selectedMetros: [],
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState: feedbackInitialState,
  reducers: {
    setQuestionAnswerLogId: (
      state: IFeedbackSlice,
      { payload }: PayloadAction<{ logId: number; qaId: string }>
    ) => {
      const { logId, qaId } = payload;
      state.logId = logId;
      state.qaId = qaId;
    },
    setFeedbackType: (
      state: IFeedbackSlice,
      { payload }: PayloadAction<string>
    ) => {
      if (payload === "up") {
        state.feedbackType = 1;
      } else if (payload === "down") {
        state.feedbackType = -1;
      }
    },
    setFeedbackDateRange: (
      state: IFeedbackSlice,
      { payload }: PayloadAction<IDateRange>
    ) => {
      if (
        state.selectedDateRange.fromDate !== payload.fromDate ||
        state.selectedDateRange.toDate !== payload.toDate ||
        state.selectedDateRange.range !== payload.range
      ) {
        state.selectedDateRange = { ...payload };
      }
    },

    setFeedbackSelectedMetros: (
      state: IFeedbackSlice,
      { payload }: PayloadAction<string[]>
    ) => {
      state.selectedMetros = payload;
    },
    setFeedbackRangeType: (
      state: IFeedbackSlice,
      { payload }: PayloadAction<string>
    ) => {
      state.selectedRangeType = payload;
    },
  },
});

export const {
  setFeedbackType,
  setQuestionAnswerLogId,
  setFeedbackDateRange,
  setFeedbackSelectedMetros,
  setFeedbackRangeType,
} = feedbackSlice.actions;
export default feedbackSlice.reducer;
